import Carousel from 'react-multi-carousel';
import {
  commonCarouselResponsiveProperties,
  commonCarouselResponsivePropertiesMobile,
} from '@/constants/carousel.constants';
import { BasicCarouselProps } from '@/types/props/components';
import clsx from 'clsx';

const BasicCarousel = ({ type, children, ...props }: BasicCarouselProps) => {
  const options =
    type === 'desktop'
      ? {
          responsive: commonCarouselResponsiveProperties,
          itemClass: clsx(props.itemClass && props.itemClass, 'px-3 pb-3'),
          containerClass: clsx(
            props.containerClass && props.containerClass,
            `mx-n15 !tw-overflow-x-clip !tw-overflow-y-visible react-multi-carousel-list-modifier`
          ),
        }
      : {
          containerClass: clsx(
            props.containerClass && props.containerClass,
            '!tw-overflow-x-clip !tw-overflow-y-visible react-multi-carousel-list-modifier'
          ),
          itemClass: clsx(
            props.itemClass && props.itemClass,
            'tw-mr-[0.45rem] pb-3'
          ),
          sliderClass: clsx(
            props.sliderClass && props.sliderClass,
            'tw-items-stretch'
          ),
          responsive: commonCarouselResponsivePropertiesMobile,
          draggable: true,
          swipeable: true,
          showDots: false,
          arrows: false,
        };
  return (
    <Carousel {...options} {...props}>
      {children}
    </Carousel>
  );
};

const BasicCarouselDesktop = ({
  children,
  ...props
}: Omit<BasicCarouselProps, 'type'>) => {
  return (
    <BasicCarousel type="desktop" {...props}>
      {children}
    </BasicCarousel>
  );
};

const BasicCarouselMobile = ({
  children,
  ...props
}: Omit<BasicCarouselProps, 'type'>) => {
  return (
    <BasicCarousel type="mobile" {...props}>
      {children}
    </BasicCarousel>
  );
};

export { BasicCarouselDesktop, BasicCarouselMobile };
